import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "1.4",
  "clip-rule": "evenodd",
  viewBox: "0 0 44 44"
};
function n(i, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "#fc0",
      d: "M26.2 22.2l-15.9-16a.6.6 0 0 1 0-.7l3.2-3.2c.2-.2.5-.2.7 0l19.5 19.5c.2.2.2.5 0 .8l-19.1 19c-.2.3-.6.3-.8 0l-3.1-3a.6.6 0 0 1 0-.9l15.5-15.5z"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
